import type { ExportOption, ParsedDocument } from '../app/types'

export function getExportOptions(document: ParsedDocument): ExportOption[] {
  switch (document.kind) {
    case 'docx':
      return [
        {
          id: 'docx',
          label: 'Word 副本',
          extension: 'docx',
          mime: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          warning: '基础文字会重新生成，复杂排版不会 100% 保留。',
        },
        { id: 'txt', label: '纯文本', extension: 'txt', mime: 'text/plain;charset=utf-8' },
        { id: 'html', label: 'HTML 阅读稿', extension: 'html', mime: 'text/html;charset=utf-8' },
      ]
    case 'xlsx':
      return [
        {
          id: 'xlsx',
          label: 'Excel 工作簿',
          extension: 'xlsx',
          mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        { id: 'csv', label: '当前表 CSV', extension: 'csv', mime: 'text/csv;charset=utf-8' },
      ]
    case 'csv':
      return [
        { id: 'csv', label: 'CSV', extension: 'csv', mime: 'text/csv;charset=utf-8' },
        {
          id: 'xlsx',
          label: 'Excel 副本',
          extension: 'xlsx',
          mime: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
      ]
    case 'md':
      return [
        { id: 'md', label: 'Markdown', extension: 'md', mime: 'text/markdown;charset=utf-8' },
        { id: 'html', label: 'HTML', extension: 'html', mime: 'text/html;charset=utf-8' },
        { id: 'txt', label: '纯文本', extension: 'txt', mime: 'text/plain;charset=utf-8' },
      ]
    case 'html':
      return [
        { id: 'html', label: 'HTML 源码', extension: 'html', mime: 'text/html;charset=utf-8' },
        {
          id: 'html-clean',
          label: '已清理 HTML',
          extension: 'html',
          mime: 'text/html;charset=utf-8',
          warning: '会导出经过清理的副本，脚本和外部资源可能已被移除。',
        },
        { id: 'txt', label: '纯文本', extension: 'txt', mime: 'text/plain;charset=utf-8' },
      ]
    case 'json':
      return [
        { id: 'json', label: 'JSON', extension: 'json', mime: 'application/json;charset=utf-8' },
        { id: 'txt', label: '纯文本', extension: 'txt', mime: 'text/plain;charset=utf-8' },
      ]
    case 'lottie':
      return [
        {
          id: 'json',
          label: 'Lottie JSON',
          extension: 'json',
          mime: 'application/json;charset=utf-8',
          warning: '导出动画 JSON，不重新打包为 .lottie。',
        },
        { id: 'txt', label: 'Plain text', extension: 'txt', mime: 'text/plain;charset=utf-8' },
      ]
    case 'txt':
    default:
      return [{ id: 'txt', label: '纯文本', extension: 'txt', mime: 'text/plain;charset=utf-8' }]
  }
}
